var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaghsim3Ofoghi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 21.1,
    width: 29.3,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 14,
    width: 29.3,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 6.3,
    width: 29.3,
    height: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6,30H0v-2.6C0,27.2,0.2,27,0.5,27S1,27.2,1,27.4V29h1.6c0.3,0,0.5,0.2,0.5,0.5S2.9,30,2.6,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,24.8c-0.3,0-0.5-0.2-0.5-0.5v-3.9C0,20.2,0.2,20,0.5,20S1,20.2,1,20.5v3.9C1,24.6,0.8,24.8,0.5,24.8z M0.5,18 C0.2,18,0,17.8,0,17.6v-3.9c0-0.3,0.2-0.5,0.5-0.5S1,13.4,1,13.7v3.9C1,17.8,0.8,18,0.5,18z M0.5,11.3c-0.3,0-0.5-0.2-0.5-0.5V6.9 c0-0.3,0.2-0.5,0.5-0.5S1,6.6,1,6.9v3.9C1,11.1,0.8,11.3,0.5,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,3C0.2,3,0,2.8,0,2.6V0h2.6c0.3,0,0.5,0.2,0.5,0.5S2.9,1,2.6,1H1v1.6C1,2.8,0.8,3,0.5,3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1,1h-3.9c-0.3,0-0.5-0.2-0.5-0.5S18.9,0,19.2,0h3.9c0.3,0,0.5,0.2,0.5,0.5S23.3,1,23.1,1z M16.3,1h-3.9 c-0.3,0-0.5-0.2-0.5-0.5S12.2,0,12.4,0h3.9c0.3,0,0.5,0.2,0.5,0.5S16.6,1,16.3,1z M9.5,1H5.7C5.4,1,5.2,0.8,5.2,0.5S5.4,0,5.7,0 h3.9C9.8,0,10,0.2,10,0.5S9.8,1,9.5,1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5,3C29.2,3,29,2.8,29,2.6V1h-1.6c-0.3,0-0.5-0.2-0.5-0.5S27.1,0,27.4,0H30v2.6C30,2.8,29.8,3,29.5,3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5,23.6c-0.3,0-0.5-0.2-0.5-0.5v-3.9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3.9C30,23.4,29.8,23.6,29.5,23.6z  M29.5,16.8c-0.3,0-0.5-0.2-0.5-0.5v-3.9c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3.9C30,16.6,29.8,16.8,29.5,16.8z M29.5,10 C29.2,10,29,9.8,29,9.5V5.7c0-0.3,0.2-0.5,0.5-0.5S30,5.4,30,5.7v3.9C30,9.8,29.8,10,29.5,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30h-2.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H29v-1.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3,30h-3.9c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3.9c0.3,0,0.5,0.2,0.5,0.5S24.6,30,24.3,30z M17.6,30h-3.9 c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h3.9c0.3,0,0.5,0.2,0.5,0.5S17.8,30,17.6,30z M10.8,30H6.9c-0.3,0-0.5-0.2-0.5-0.5 S6.7,29,6.9,29h3.9c0.3,0,0.5,0.2,0.5,0.5S11.1,30,10.8,30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaghsim3Ofoghi);
export default __webpack_public_path__ + "static/media/taghsim_3_ofoghi.cba9fceb0f5e0dd5cc31ea37ac012aec.svg";
export { ForwardRef as ReactComponent };